import { useParams } from 'react-router-dom'
import LanguageForm from './LanguageForm'

const View = () => {
    const params = useParams()

    return (
        <LanguageForm
            id={parseInt(params.languageId)}
            config={{
                submitSuccessMsg: {
                    header: 'Updated',
                    message: 'Language updated successfully',
                },
                submitFailedMsg: {
                    header: 'Failed',
                    message: 'Failed to update language',
                },
                saveButton: {
                    label: 'Update',
                    savingLabel: 'Updating language...',
                },
            }}
        />
    )
}

export default View
